//sidebar SHOW
export const SET_SIDEBAR_SHOW = 'SET_SIDEBAR_SHOW';
export const GET_SIDEBAR_SHOW = 'GET_SIDEBAR_SHOW';
